import { useMutation } from '@apollo/client';
import { useCallback } from 'react';
import { gql } from '../graphql/generated/gql';
import { EntityType } from '../graphql/generated/graphql';
import type { EntityUploadType } from '../graphql/generated/graphql';

const UPLOAD_ENTITY_ASSET_MUTATION = gql(/** @complexity 2 */ `
  mutation uploadEntityAsset(
    $file: Upload
    $url: String
    $entityType: EntityType!
    $entityId: ID!
    $uploadType: EntityUploadType!
  ) {
    asset: uploadEntityAsset(
      file: $file
      url: $url
      uploadType: $uploadType
      entityType: $entityType
      entityId: $entityId
    ) {
      url
    }
  }
`);

export default function useUploadPostAsset(postId: string) {
  const [uploadAsset] = useMutation(UPLOAD_ENTITY_ASSET_MUTATION);

  return useCallback(
    async (source: File | string, type: EntityUploadType) => {
      const { data } = await uploadAsset({
        variables: {
          entityId: postId,
          entityType: EntityType.Post,
          uploadType: type,
          ...(source instanceof File ? { file: source } : { url: source }),
        },
      });

      return data?.asset?.url ?? null;
    },
    [uploadAsset, postId],
  );
}
